<template>
	<div id="dljl" v-loading="loading">
		<div class="query_info">
			<el-date-picker
				v-model="beginDate"
				type="datetime"
				placeholder="开始日期"
				class="dateStyle"
				value-format="yyyy-MM-dd HH:mm"
			>
			</el-date-picker>
			<el-date-picker
				v-model="endDate"
				type="datetime"
				placeholder="结束日期"
				class="dateStyle"
				value-format="yyyy-MM-dd HH:mm"
			>
			</el-date-picker>
			<el-button type="primary" class="cxBtn" @click="cxBtn">查询</el-button>
		</div>
		<div class="tableData czTable">
			<el-table :data="tableData" border stripe style="width: 100%">
				<el-table-column prop="LoginTermText" label="类型" width="100" />
				<el-table-column prop="LoginIp" label="IP" width="160" />
				<el-table-column prop="LoginAddress" label="IP地址" width="160" />
				<el-table-column prop="LoginTermText" :formatter="formatDetail" label="详细" />
				<el-table-column prop="LoginTime" label="登录时间" width="170" />
				<div slot="empty">
					<!-- 表格为空的样式 -->
					<div class="table-empty">
						<img src="@/static/img/zjzh/empty.png" alt="" />
						<div class="table-empty-text">暂无记录</div>
					</div>
				</div>
			</el-table>
		</div>
		<div class="my-paging" v-show="tableData.length !== 0">
			<div class="everyPageShow">每页显示 10 条</div>
			<div class="totalNum">共{{ paginationArray.total }}条</div>
			<el-pagination
				@current-change="handleCurrentChange"
				:hide-on-single-page="paginationArray.total <= 1"
				:page-size="paginationArray.currpageSize"
				layout="prev, pager, next, jumper"
				:total="paginationArray.total"
				background
			/>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			Maxheight: null,
			beginDate: "",
			endDate: "",
			//表格数据
			tableData: [],
			paginationArray: {
				total: 0,
				currpageSize: 10, //当页条数
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},
	mounted() {
		this.initDate();
		this.cxBtn();
	},
	methods: {
		_initHeight() {
			if (this.tableData.length === 0) {
				this.Maxheight = null;
			}
			if (this.tableData.length >= 10) {
				this.Maxheight = 350;
			}
		},
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.cxBtn();
		},
		//查询
		cxBtn() {
			let that = this;
			let url = "Api/User/UserLoginLogInfo";
			let cxData = {
				StartTime: this.beginDate,
				EndTime: this.endDate,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
			};
			this.loading = true;
			postAjax(url, cxData)
				.then(data => {
					setTimeout(() => {
						this.loading = false;
					}, 100);
					if (data.IsSucess) {
						that.paginationArray.total = data.Data.total;
						that.tableData = data.Data.rows;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.cxBtn();
		},
		formatDate(row, column) {
			var arr = row[column.property].split("T");
			var arr1 = arr[1].split(".");
			return arr[0] + " " + arr1[0];
		},
		//格式化详情数据
		formatDetail(row) {
			return "用户" + row.LoginName + "登录,平台：" + row.LoginTermText;
		},
	},
};
</script>
<style type="scss">
#dljl {
	height: 100%;
	padding: 20px 0px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UserComps/dljl.vue